<template>
	<div class="container page">
		<div class="header">
			<van-nav-bar :title="$t('other.account_info')" class="nav-bar">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
			<div class="info">
				<p class="title">{{$t("withdraw.task_money")}}({{$t("EUR")}})</p>
				<p class="value">{{ personalreport.profit_loss }}</p>
				<p class="tip">{{$t("reservation.win_formula")}}</p>
			</div>
			<div class="content">
				<div class="datalist">
					<div class="datalistitem">
						<div class="datalistitemValue">{{ personalreport.order }}</div>
						<div class="datalistitemKey">{{$t("other.task_quantity")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ personalreport.recharge}}</div>
						<div class="datalistitemKey">{{$t("other.recharge_amount")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ personalreport.withdraw }}</div>
						<div class="datalistitemKey">{{$t("other.withdraw_amount")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ personalreport.win }}</div>
						<div class="datalistitemKey">{{$t("other.winning_amount")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				personalreport: {}
			};
		},
		created() {
			this.getPersonalreport();
		},
		methods: {
			back() {
				return window.history.back();
			},
			getPersonalreport() {
				this.$http({
					method: 'get',
					url: 'getAccountInfo'
				}).then(res => {
					if (res.code === 1) {
						this.personalreport = res.data;
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .header {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 20px;
		padding-top: 10px;
		margin: auto;
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		background: #f2f2f5;
	}

	.container .content .datalist {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-start;
	}

	.container .content .datalist .datalistitem {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 200px;
		width: 49.5%;
	}

	.container .content .datalist .datalistitem .datalistitemValue {
		color: #ff253f;
		font-size: 35px;
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.container .content .datalist .datalistitem .datalistitemKey {
		color: #979799;
		font-size: 25px;
		margin-bottom: 10px;
		margin-top: 10px;
	}
</style>